export default "__VITE_ASSET__7373a5f1__"